
import { Injectable } from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl
} from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class PdfSanitizerService {
  constructor(private sanitizer: DomSanitizer) {}

  getTrustedPdfUrl(base64String: string): SafeResourceUrl | null {
    const cleanBase64 = base64String?.trim();

    if (
      !cleanBase64 ||
      !/^[A-Za-z0-9+/=]+$/.test(cleanBase64) ||
      !cleanBase64.startsWith('JVBERi0')
    ) {
      return null;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:application/pdf;base64,${cleanBase64}`
    );
  }
}